export const LAZY_PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

export const getLazyImageAttributes = ({ src, eager }) => {
    if (!src) {
        return eager ? {} : { src: LAZY_PLACEHOLDER };
    }

    return eager
        ? { src }
        : { src: LAZY_PLACEHOLDER, 'data-src': src };
};

export const getLazySourceAttributes = ({ srcSet, eager }) => {
    if (!srcSet) {
        return {};
    }

    return eager
        ? { srcSet }
        : { 'data-srcset': srcSet };
};

export const getLazyBackgroundAttributes = ({ src, eager }) => {
    if (!src) {
        return { style: undefined, dataBackground: undefined };
    }

    return eager
        ? { style: { backgroundImage: `url(${src})` }, dataBackground: undefined }
        : { style: undefined, dataBackground: src };
};

export const registerSwiperLazyLoader = (swiperInstance, totalSlides) => {
    if (!swiperInstance || !Number.isFinite(totalSlides) || totalSlides <= 0) {
        return () => { };
    }

    const normalizeIndex = (index) => {
        const total = totalSlides;
        return ((index % total) + total) % total;
    };

    const hydrateSlideMedia = (slideEl) => {
        if (!slideEl) return;
        if (slideEl.dataset.lazyLoaded === 'true') return;

        const backgroundData = slideEl.getAttribute('data-background');
        if (backgroundData && slideEl.dataset.backgroundLoaded !== 'true') {
            slideEl.style.backgroundImage = `url(${backgroundData})`;
            slideEl.dataset.backgroundLoaded = 'true';
        }

        const backgroundTargets = slideEl.querySelectorAll('[data-background]');
        backgroundTargets.forEach((el) => {
            if (el.dataset.backgroundLoaded === 'true') return;
            const pendingBackground = el.getAttribute('data-background');
            if (!pendingBackground) return;
            el.style.backgroundImage = `url(${pendingBackground})`;
            el.dataset.backgroundLoaded = 'true';
        });

        const sources = slideEl.querySelectorAll('source[data-srcset]');
        sources.forEach((sourceEl) => {
            const pendingSrcset = sourceEl.getAttribute('data-srcset');
            if (!pendingSrcset) return;
            sourceEl.setAttribute('srcset', pendingSrcset);
            sourceEl.removeAttribute('data-srcset');
        });

        const images = slideEl.querySelectorAll('img[data-src]');
        images.forEach((imgEl) => {
            const pendingSrc = imgEl.getAttribute('data-src');
            if (!pendingSrc) return;
            imgEl.setAttribute('src', pendingSrc);
            imgEl.removeAttribute('data-src');
        });

        slideEl.dataset.lazyLoaded = 'true';
    };

    const loadSlidesForRealIndex = (realIndex) => {
        const normalizedIndex = normalizeIndex(realIndex);
        const slideElements = Array.from(swiperInstance.slides || []);

        slideElements.forEach((slideEl) => {
            const slideIndexAttr = slideEl.getAttribute('data-swiper-slide-index');
            if (slideIndexAttr === null) return;
            if (Number(slideIndexAttr) !== normalizedIndex) return;

            hydrateSlideMedia(slideEl);
        });
    };

    const hydrateAround = (realIndex) => {
        loadSlidesForRealIndex(realIndex);
        loadSlidesForRealIndex(realIndex + 1);
    };

    const handleSlideChangeStart = () => {
        hydrateAround(swiperInstance.realIndex);
    };

    swiperInstance.on('slideChangeTransitionStart', handleSlideChangeStart);
    hydrateAround(swiperInstance.realIndex);

    return () => {
        swiperInstance.off('slideChangeTransitionStart', handleSlideChangeStart);
    };
};
